module.exports = __webpack_public_path__ + "static/img/product_07.c408e27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_07.jpg
// module id = /G0/
// module chunks = 2